// App
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const SETUP_APP = 'SETUP_APP';
export const LOADING_PROCCESS = 'LOADING_PROCCESS';
export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';
export const PUSH_ALERT = 'PUSH_ALERT';
export const POP_ALERT = 'POP_ALERT';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';

// UI
export const SET_SELECTED_CATEGORY_ID = 'SET_SELECTED_CATEGORY_ID';
export const CLEAR_CART_ITEM_ANIMATION = 'CLEAR_CART_ITEM_ANIMATION';
export const SHOW_CART_MODAEL = 'SHOW_CART_MODAEL';

// Business
export const FETCH_BRANCHES = 'FETCH_BRANCHES';
export const SET_BRANCH = 'SET_BRANCH';
export const RESET_BRANCH = 'RESET_BRANCH';

// Menu
export const FETCH_RESTAURANT_MENU = 'FETCH_RESTAURANT_MENU';
export const FETCH_UPSELLS_DATA = 'FETCH_UPSELLS_DATA';
export const TRIGGER_UPSELL = 'TRIGGER_UPSELL';
export const END_UPSELL = 'END_UPSELL';

// Customer
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO';

// Order
export const START_ORDER = 'START_ORDER';
export const SAVE_DELIVERY_INFO = 'SAVE_DELIVERY_INFO';
export const CALC_FINAL_CHECK = 'CALC_FINAL_CHECK';
export const SET_REMARK_TO_ORDER = 'SET_REMARK_TO_ORDER';

// Cart
export const RESET_CART = 'RESET_CART';
export const SET_ORDER_TYPE = 'SET_ORDER_TYPE';
export const SET_ORDER_TIP = 'SET_ORDER_TIP';
export const SET_CART_VALID = 'SET_CART_VALID';
export const SET_ITEM_TO_CART = 'SET_ITEM_TO_CART';
export const SET_ITEM_TO_CONSTRUCTION = 'SET_ITEM_TO_CONSTRUCTION';
export const REMOVE_ITEM_FROM_CONSTRUCTION = 'REMOVE_ITEM_FROM_CONSTRUCTION';
export const REMOVE_ITEM_FROM_CART = 'REMOVE_ITEM_FROM_CART';
export const UPDATE_ITEM_IN_CART = 'UPDATE_ITEM_IN_CART';
export const COPY_ITEM = 'COPY_ITEM';
export const CART_CHECKOUT = 'CART_CHECKOUT';
export const SET_ORDER_OWNER = 'SET_ORDER_OWNER';
export const CLEAN_CART = 'CLEAN_CART';
export const CALC_FOR_CHECKOUT = 'CALC_FOR_CHECKOUT';
export const PROCESS_TRANSACTIONS = 'PROCESS_TRANSACTIONS';
export const CHECKOUT_RESOLVED = 'CHECKOUT_RESOLVED';
export const WAIT_FOR_TRANSACTION = 'WAIT_FOR_TRANSACTION';

// Loyalty
export const SHOW_LOYALTY_PANEL = 'SHOW_LOYALTY_PANEL';
export const LOGIN_LOYALTY_MEMBER = 'LOGIN_LOYALTY_MEMBER';
export const SELECT_BENEFIT = 'SELECT_BENEFIT';
export const UNSELECT_BENEFIT = 'UNSELECT_BENEFIT';
export const ENABLE_CREDITS_USAGE = 'ENABLE_CREDITS_USAGE';
export const VALIDATE_COUPON = 'VALIDATE_COUPON';
